import React, { useState, useEffect, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { fetchFavoriteCars } from "../../_services/carsService";
import { WishlistContext } from "../../context/WishlistContext";
import AvatarDefault from "../../assets/img/avatars/01.jpg"
import { fetchNotifications } from "../../_services/userService";

const Header = ({ onLoginClick }) => {
  const navigate = useNavigate();
  const { wishlistCount } = useContext(WishlistContext);
  const { isLoggedIn, logout, userInfo, updateAvatar } = useContext(AuthContext);
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [avatar, setAvatar] = useState(AvatarDefault);
  const [notificationCount, setNotificationCount] = useState(0); // New: notification count

  useEffect(() => {
    getCars();
  }, [wishlistCount]);

  useEffect(() => {
    console.log("Header userInfo updated:", userInfo);
  }, [userInfo]);

  useEffect(() => {
    if (isLoggedIn) {
      fetchNotifications();
    }
  }, [isLoggedIn]);

  const getCars = async () => {
    try {
      const data = await fetchFavoriteCars();
      setCars(data);
    } catch (err) {
      setError(err);
    }
  };

  const fetchNotifications = async () => {
    try {
      // Simulating API response, replace with real API call
      const fakeNotifications = 3;
      setNotificationCount(fakeNotifications);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const handleSellCar = () => {
    if (isLoggedIn) {
      navigate("/sell-car");
    } else {
      localStorage.setItem("postLoginAction", "/sell-car");
      const loginEvent = new Event("openLoginModal");
      window.dispatchEvent(loginEvent);
      return;
    }
  };

  const handleLoginClick = () => {
    const loginEvent = new Event("openLoginModal");
    window.dispatchEvent(loginEvent);
  };

  return (
    <header
      className="navbar navbar-expand-lg fixed-top navbar-stuck bg-white"
      data-scroll-header
      style={{ borderBottom: "solid 1px #e3e3e3" }}
    >
      <div className="container" style={{ marginLeft: "70px" }}>
        <Link to="/" className="navbar-brand text-primary fw-bold fs-3 me-3 me-xl-4">
          XLR8
        </Link>

        {isLoggedIn && (
          <div className="dropdown d-none d-lg-block order-lg-3 my-n2">
            <span className="d-block py-2 cursor-pointer d-flex align-items-center gap-2">
              {/* Notification Bell */}
              <div className="position-relative me-2">
                <i className="fi-bell fs-4"></i>
                {notificationCount > 0 && (
                  <span
                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                    style={{ fontSize: '10px' }}
                  >
                    {notificationCount}
                  </span>
                )}
              </div>

              {/* User Avatar and Name */}
              <img
                className="rounded-circle"
                src={userInfo?.image_url || avatar}
                width="40"
                height="40"
                style={{ borderRadius: '50%' }}
                alt={userInfo?.name || "User"}
              />
              <span className="ms-2">
                {userInfo && userInfo.email ? userInfo.email.split("@")[0] : ""}
              </span>
            </span>

            <div className="dropdown-menu dropdown-menu-dark dropdown-menu-end">
              <div
                className="d-flex align-items-start border-bottom border-light px-3 py-1 mb-2"
                style={{ width: "16rem" }}
              >
                <img
                  className="rounded-circle"
                  src={userInfo?.image_url || avatar}
                  alt={userInfo?.name || "User"}
                  width="40"
                  height="40"
                  style={{ borderRadius: '50%' }}
                />
                <div className="ps-2">
                  <h6 className="fs-base text-light mb-0">
                    {userInfo && userInfo.name
                      ? userInfo.name
                      : userInfo?.email?.split("@")[0] || "EMAIL"}
                  </h6>
                  <span className="star-rating star-rating-sm">
                    <i className="star-rating-icon fi-star-filled active"></i>
                    <i className="star-rating-icon fi-star-filled active"></i>
                    <i className="star-rating-icon fi-star-filled active"></i>
                    <i className="star-rating-icon fi-star-filled active"></i>
                    <i className="star-rating-icon fi-star-filled active"></i>
                  </span>
                  {userInfo?.phone_number && (
                    <div className="fs-xs py-2">
                      {userInfo?.phone_number}
                      <br />
                      {userInfo?.email}
                    </div>
                  )}
                </div>
              </div>

              <Link to="/account/profile" className="dropdown-item">
                <i className="fi-user me-2"></i>Personal Info
              </Link>

              <Link to="/account/my-listing" className="dropdown-item">
                <i className="fi-car me-2"></i>My Listing
              </Link>

              <Link to="/account/favorites" className="dropdown-item">
                <i className="fi-heart me-2"></i>Wishlist
                <span className="badge bg-faded-light ms-2">{cars.length}</span>
              </Link>

              <div className="dropdown-divider"></div>

              <a className="dropdown-item" onClick={logout} href="/">
                Sign Out
              </a>
            </div>
          </div>
        )}

        {!isLoggedIn && (
          <a
            className="btn btn-link btn-sm d-none d-lg-block order-lg-5"
            onClick={handleLoginClick}
            data-bs-toggle="modal"
            style={{ marginRight: "-50px" }}
          >
            <i className="fi-user me-2"></i>Sign in
          </a>
        )}

        <div
          className="collapse navbar-collapse justify-content-center order-lg-2"
          id="navbarNav"
        >
          <ul
            className="navbar-nav navbar-nav-scroll flex flex-row items-center justify-center gap-8"
            style={{ maxHeight: "35rem", gap: "2rem", flexDirection: "row" }}
          >
            <li className="nav-item">
              <NavLink
                to="/auctions"
                end
                className={({ isActive }) => "nav-link" + (isActive ? " active" : "")}
              >
                Auctions
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="active" to="/aboutus" className="nav-link">
                About Us
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink activeClassName="active" to="/faq" className="nav-link">
                FAQs
              </NavLink>
            </li>
            <li>
              <button
                onClick={handleSellCar}
                className="btn btn-sm btn-primary order-lg-3 me-3"
              >
                Sell Car
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
